import { Banner } from "@dropbox/dig-components/banner";
import { Button } from "@dropbox/dig-components/buttons";
import { Text } from "@dropbox/dig-components/typography";
import { UIIcon } from "@dropbox/dig-icons";
import { WarningLine } from "@dropbox/dig-icons/dist/mjs/assets";
import useConnectors from "@mirage/service-connectors/useConnectors";
import i18n from "@mirage/translations";
import { useLocation } from "react-router-dom";
import { useConnectorsUI } from "../SettingsPage/useConnectorsUI";
import styles from "./ConnectorIssuesNotificationBanner.module.css";

import type { GlobalBannerProps } from "@mirage/mosaics/GlobalBanners/GlobalBannersProps";

export default function ConnectorIssuesNotificationBanner({
  bannerClass,
  isGlobalBanner,
}: GlobalBannerProps & {
  isGlobalBanner?: boolean;
}) {
  // Hooks
  const { openConnectors } = useConnectorsUI();
  const { hasExpiredConnections, hasReauthConnections } = useConnectors();
  const location = useLocation();

  // No need to display the banner on the settings page.
  if (
    (location.pathname.indexOf("/settings") === 0 &&
      // If this is the global banner, then don't show it on the apps page either
      (location.pathname.indexOf("/settings/apps") !== 0 || isGlobalBanner)) ||
    !(hasExpiredConnections || hasReauthConnections)
  ) {
    return null;
  }

  return (
    <div className={bannerClass}>
      <Banner
        type="alert"
        withLeftIcon={<UIIcon src={WarningLine} />}
        className={styles.messageBannerContainer}
      >
        <Banner.Message>
          <Text>
            {hasExpiredConnections
              ? i18n.t("connected_apps_issue")
              : i18n.t("connected_apps_issue_reauth")}
          </Text>
        </Banner.Message>
        {isGlobalBanner && (
          <Button variant="transparent" onClick={() => openConnectors()}>
            {i18n.t("connected_apps_issue_ack_btn")}
          </Button>
        )}
      </Banner>
    </div>
  );
}
